import { Dropdown, styled } from '@creditas-ui/react'

export const ListFilters = styled.div`
  & div:nth-of-type(3) {
    display: none;
  }

  & div:nth-of-type(4) {
    display: none;
  }

  & div:nth-of-type(5) {
    display: none;
  }

  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 2fr;
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  grid-template-areas:
                        "${'search '.repeat(12)}"
                        "${'step '.repeat(12)}"
                        "${'status '.repeat(12)}"
                        "${'date '.repeat(12)}";

  @media (min-width: 980px) {
    grid-template-rows: 1fr;
    grid-template-areas: '${'search '.repeat(
  6,
)} ${'step '.repeat(2)} ${'status '.repeat(2)} ${'date '.repeat(2)}';

    & div:nth-of-type(3) {
      display: block;
    }

    & div:nth-of-type(4) {
      display: block;
    }

    & div:nth-of-type(5) {
      display: block;
    }

  }
`

export const Collaterals = styled(Dropdown)`
  flex: 1;
  p {
    text-align: left;
    position: absolute;
    left: 20px;
    transition: all 0.2s;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 60px);
    top: 16px;
  }
`

export const Steps = styled(Dropdown)`
  flex: 1;
`
